import './styles.scss';

import moment from 'moment';

const ArticleListItem = () => import('../article-list-item/index.vue');
const SignOutButton = () => import('../sign-out-button/index.vue');
const AddContactButton = () => import('../add-contact-button/index.vue');
const AddFixtureButton = () => import('../add-fixture-button/index.vue');
const MessagingMenu = () => import('../messaging-menu/index.vue');

export default {
    name: 'SideMenu',

    components: {
        'list-item': ArticleListItem,
        'sign-out-button': SignOutButton,
        'add-contact-button': AddContactButton,
        'add-fixture-button': AddFixtureButton,
        'messaging-menu': MessagingMenu
    },

    computed: {
        menu_items() {
            return this.$store.state.menu_items;
        },

        menu() {
            return this.$store.state.menu_details;
        },
        subscription() {
            return this.$store.getters.getActiveSubscription;
        },
        canEdit() { 
            return this.subscription.permissions.includes('ugc_create');
        }
    },

    methods: {
        navigateExternal(url) {
            window.open(url, '_blank');
        },

        formatDate(data) {
            return moment(data).fromNow();
        }
    }
};